
  import {
    Component,
    Prop,
    Vue
  } from "vue-property-decorator";
  import CollapseItem from '@/components/collapse.vue';

  @Component({
    name: 'performance-block',
    components: {
      CollapseItem
    }
  })
  export default class PerformanceBlock extends Vue {
    @Prop({}) private info!: any
    @Prop({}) private level:number

  }
